import React from 'react';
import Card from './Card';

/**
 * Renders the player's 3 face-up cards.
 * During swap phase, clicking a face-up card selects it as the swap target.
 *
 * Props:
 *   cards        — array of card objects
 *   swapPhase    — boolean, enables selection
 *   selectedId   — currently selected face-up card id
 *   onSelect     — (cardId) => void
 */
const FaceUpCards = ({ cards = [], swapPhase = false, selectedId, onSelect }) => (
  <div className="card-row face-up-row">
    <p className="card-row-label">Face Up</p>
    <div className="cards">
      {cards.map((c, i) => (
        <Card
          key={c.id || i}
          card={c}
          selected={swapPhase && c.id === selectedId}
          onClick={swapPhase && onSelect ? () => onSelect(c.id) : undefined}
        />
      ))}
      {Array.from({ length: Math.max(0, 3 - cards.length) }).map((_, i) => (
        <div key={`empty-${i}`} className="card card-empty" />
      ))}
    </div>
  </div>
);

export default FaceUpCards;
